import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MerchantCurrencyPipe } from '../../../shared/pipes/merchant-currency.pipe';
import { PaymentMethodPipe } from '../../../shared/pipes/payment-method.pipe';
import { DatePipe } from '@angular/common';
import { ISaleStatus } from '../../../core/services/invoicing.service';

@Component({
  selector: 'app-payment-history-summary',
  imports: [TranslatePipe, MerchantCurrencyPipe, PaymentMethodPipe, DatePipe],
  templateUrl: './payment-history-summary.component.html',
  styleUrl: './payment-history-summary.component.scss'
})
export class PaymentHistorySummaryComponent {
  @Input() paymentHistory: any;

  ISaleStatus = ISaleStatus;
}
